import { get, getDatabase, onValue, ref } from "firebase/database";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { useNavigate } from "react-router-dom";
import Pricing from "./pricing/Pricing";
function PlanAndBill({ isOpen, onClose, children }) {
  const [comCurrent, setComCurrent] = useState(2);
  const [isPricing, setIsPricing] = useState(false);
  const total = 15;

  const comPercentage = (comCurrent / total) * 100;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;
  return (
    <>
      <Pricing isOpen={isPricing} onClose={() => setIsPricing(false)} />
      <div className='modal-overlay' onClick={onClose}>
        <div
          className='modal-content'
          onClick={(e) => e.stopPropagation()} // Prevent closing on content click
        >
          <button className='modal-close' onClick={onClose}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 24 24'
              width='32'
              height='32'
              fill='currentColor'
            >
              <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
            </svg>
          </button>
          <div className='theaccountcnnt'>
            <h1 className='acntitle'>Plan and Billing</h1>
            <p className='acntparag'>
              Change or update your Subscription, plan and keep track of your
              billing settings.
            </p>
            <div className='thespacee'></div>
            <div className='thelklaks'>
              <div className='alksj'>
                <p className='alslha'>Subscription</p>
                <p className='kasys'>Free plan</p>
              </div>
              <div className='akslla'>
                <p className='dlkask'>No upcoming bill</p>
                <div className='thespace'></div>
                <p className='aksjals'>
                  You're on a free plan, so you don't have any upcoming charges
                </p>
              </div>
            </div>
            <div className='thespace'></div>
            <div className='lashw'>
              <p className='alslha'>Usage</p>
              <div className='thespacee'></div>
              <div className='lkashlkah'>
                <div className='aksjhs'>
                  <p className='ajsj'>Complimentary services annually,</p>
                  <div className='thespace'></div>
                  <div className='progress-text'>
                    {comCurrent} / {total} ({Math.round(comPercentage)}%)
                  </div>
                  <div className='thespace'></div>
                  <div className='progress-bar-background'>
                    <div
                      className='progress-bar-fill'
                      style={{ width: `${comPercentage}%` }}
                    ></div>
                  </div>
                </div>
                <div className='aksjhs'>
                  <p className='ajsj'>
                    Extra 5% discount when you setup automatic payment.
                  </p>
                  <div className='thespace'></div>
                  <div className='progress-text'>
                    {comCurrent} / {total} ({Math.round(comPercentage)}%)
                  </div>
                  <div className='thespace'></div>
                  <div className='progress-bar-background'>
                    <div
                      className='progress-bar-fill'
                      style={{ width: `${comPercentage}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className='thespace'></div>
            <div className='lashw'>
              <p className='alslha'>Manage plan</p>
              <div className='thespacee'></div>
              <button className='lajsh' onClick={() => setIsPricing(true)}>
                Change Plan
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PlanAndBill;
